import { render, staticRenderFns } from "./CreatePlusTemplateListTabs.vue?vue&type=template&id=494ce3a1&scoped=true&"
import script from "./CreatePlusTemplateListTabs.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTemplateListTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ce3a1",
  null
  
)

export default component.exports